import {isPlainObject} from './isPlainObject';
import {ObjectIndex} from '../common/index/ObjectIndex';

export function isRecord<T = unknown>(o?: any): o is Record<ObjectIndex, T> {
    return isPlainObject(o);
}